module.exports = __webpack_public_path__ + "static/media/video-home.89a8f43a.mp4";